/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './pagination.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../app/shared/components/pagination/pagination.component';
import * as i3 from '../../../../../$$_gendir/node_modules/ngx-bootstrap/pagination/pagination.component.ngfactory';
import * as i4 from 'ngx-bootstrap/pagination/pagination.component';
import * as i5 from 'ngx-bootstrap/pagination/pagination.config';
import * as i6 from '@angular/forms';
const styles_PaginationComponent:any[] = [i0.styles];
export const RenderType_PaginationComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_PaginationComponent,data:{}});
export function View_PaginationComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),6,'pagination',
      [['firstText','«'],['lastText','»'],['nextText','›'],['previousText','‹']],[[2,
          'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
          (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
          [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
          'pageChanged'],[(null as any),'ngModelChange']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i2.PaginationComponent = _v.component;
        if (('pageChanged' === en)) {
          const pd_0:any = ((<any>_co.pageChanged($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_1:any = ((<any>(_co.currentPage = $event)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i3.View_PaginationComponent_0,i3.RenderType_PaginationComponent)),i1.ɵdid(1,
      114688,(null as any),0,i4.PaginationComponent,[i1.Renderer,i1.ElementRef,i5.PaginationConfig],
      {maxSize:[0,'maxSize'],boundaryLinks:[1,'boundaryLinks'],firstText:[2,'firstText'],
          previousText:[3,'previousText'],nextText:[4,'nextText'],lastText:[5,'lastText'],
          disabled:[6,'disabled'],itemsPerPage:[7,'itemsPerPage'],totalItems:[8,'totalItems']},
      {pageChanged:'pageChanged'}),i1.ɵprd(1024,(null as any),i6.NG_VALUE_ACCESSOR,
      (p0_0:any) => {
        return [p0_0];
      },[i4.PaginationComponent]),i1.ɵdid(3,671744,(null as any),0,i6.NgModel,[[8,
      (null as any)],[8,(null as any)],[8,(null as any)],[2,i6.NG_VALUE_ACCESSOR]],
      {isDisabled:[0,'isDisabled'],model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,
      (null as any),i6.NgControl,(null as any),[i6.NgModel]),i1.ɵdid(5,16384,(null as any),
      0,i6.NgControlStatus,[i6.NgControl],(null as any),(null as any)),(_l()(),i1.ɵted(-1,
      (null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i2.PaginationComponent = _v.component;
    const currVal_7:any = _co.maxSize;
    const currVal_8:any = true;
    const currVal_9:any = '«';
    const currVal_10:any = '‹';
    const currVal_11:any = '›';
    const currVal_12:any = '»';
    const currVal_13:boolean = !_co.totalTab;
    const currVal_14:any = _co.itemsPerPage;
    const currVal_15:any = _co.totalTab;
    _ck(_v,1,0,currVal_7,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,
        currVal_14,currVal_15);
    const currVal_16:boolean = !_co.totalTab;
    const currVal_17:any = _co.currentPage;
    _ck(_v,3,0,currVal_16,currVal_17);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,5).ngClassUntouched;
    const currVal_1:any = i1.ɵnov(_v,5).ngClassTouched;
    const currVal_2:any = i1.ɵnov(_v,5).ngClassPristine;
    const currVal_3:any = i1.ɵnov(_v,5).ngClassDirty;
    const currVal_4:any = i1.ɵnov(_v,5).ngClassValid;
    const currVal_5:any = i1.ɵnov(_v,5).ngClassInvalid;
    const currVal_6:any = i1.ɵnov(_v,5).ngClassPending;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
export function View_PaginationComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-pagination',
      ([] as any[]),(null as any),(null as any),(null as any),View_PaginationComponent_0,
      RenderType_PaginationComponent)),i1.ɵdid(1,638976,(null as any),0,i2.PaginationComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const PaginationComponentNgFactory:i1.ComponentFactory<i2.PaginationComponent> = i1.ɵccf('app-pagination',
    i2.PaginationComponent,View_PaginationComponent_Host_0,{totalTab:'totalTab',nowPage:'nowPage',
        maxSize:'maxSize',itemsPerPage:'itemsPerPage'},{page:'page'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/shared/components/pagination/pagination.component.ngfactory.ts